import {StrictMode} from "react";
import {createRoot, type Root} from "react-dom/client";
import {Bootstrap} from "./Bootstrap";

if (import.meta.hot) {
    import.meta.hot.accept();
}

const container = document.querySelector("#app");

if (container) {
    const root = ensureRoot(container);
    root.render(
        <StrictMode>
            <Bootstrap />
        </StrictMode>,
    );
}

function ensureRoot(container: Element): Root {
    if (import.meta.hot) {
        return (import.meta.hot.data.root ??= createRoot(container));
    }

    return createRoot(container);
}
